import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function TPUL
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={32}
            adderFlag={20}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default TPUL
